















































































import { Component, Vue } from 'vue-property-decorator';
import Topbar from '@/components/Topbar.vue';
import Carousel from '@/components/Carousel.vue';
import SearchStore from '@/store/SearchStore';
import { GoogleMapsService } from '@/services/GoogleMaps';

@Component({
  components: {
    Topbar,
    Carousel,
  },
})
export default class Search extends Vue {
  public returnRoute: string = 'home';
  public query: string = '';
  public predictions: any[] = [];
  public gapiReady: boolean = false;
  public loading: boolean = false;
  public apiError: any = null;

  public mounted() {
    this.returnRoute = this.$route.params.returnRoute || 'home';

    GoogleMapsService.loadGoogleApi().then(async () => {
      this.gapiReady = true;
    });
  }

  public close() {
    this.$router.push({ name: this.returnRoute });
  }

  public async getPredictions() {
    this.predictions = await GoogleMapsService.getPredictions(this.query);
  }

  public async selectLocation(prediction: any) {
    const geoDetails = await GoogleMapsService.geocode(prediction.description);
    SearchStore.Search(geoDetails);

    this.$router.push({
      name: 'search-results',
      params: {
        query: encodeURI(geoDetails.query),
      },
    });
  }
}
